module.exports = __webpack_public_path__ + "static/media/book.05008925.svg";